export default __webpack_public_path__ + "static/MC_dla2-0b74453a90401a4a3b5f77e050116069.png";